module.exports = __webpack_public_path__ + "static/media/HowItWorksUploadFiles.865381e9.svg";